import React from 'react'
import {
  GetReportDetailsFragmentFragment,
  useCreatePdfReportMutation,
} from 'gqlTypes'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo'
import { useCurrentUserContext } from '../../contexts/CurrentUserContext'
import { Tenant } from 'types'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { Box } from '@mui/material'

interface Props {
  report: GetReportDetailsFragmentFragment
  tenant?: Tenant | null
}
const ReportOverviewActions: React.FC<Props> = ({ report, tenant }) => {
  const currentUser = useCurrentUserContext()

  const onClickOpenAll = () => {
    for (const dm of report.downloadMaterials) {
      window.open(`/download_materials/${dm.id}`)
    }
    for (const sdm of report.scrapedDownloadMaterials) {
      sdm.cleanedLink && window.open(sdm.cleanedLink)
    }
  }

  const sortedDirectDownloads = [...report.downloadMaterials].sort((a, b) =>
    (a.title || '').localeCompare(b.title || '')
  )

  const [createPdfReport] = useCreatePdfReportMutation()

  const handleDownloadPdf = () => {
    createPdfReport({
      variables: { input: { reportId: report.id, onlyFavorites: false } },
    }).then((rslt) => {
      console.log('createPdfReport rslt', rslt)
      const createPdfReport = rslt.data?.createPdfReport
      if (
        createPdfReport &&
        createPdfReport.success &&
        createPdfReport.pdfReport
      ) {
        const url = `/pdf/${createPdfReport.pdfReport.randomKey}`
        window.open(url, '_blank')
      }
    })
  }

  const handleDownloadFavoritesPdf = () => {
    createPdfReport({
      variables: { input: { reportId: report.id, onlyFavorites: true } },
    }).then((rslt) => {
      const createPdfReport = rslt.data?.createPdfReport
      if (
        createPdfReport &&
        createPdfReport.success &&
        createPdfReport.pdfReport
      ) {
        const url = `/pdf/${createPdfReport.pdfReport.randomKey}`
        window.open(url, '_blank')
      }
    })
  }

  return (
    <Paper sx={{ px: 4, py: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        {tenant?.body_class === 'youthtruth_subdomain'
          ? 'Additional Resources'
          : 'Supplemental Materials'}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<PictureAsPdfIcon />}
        sx={{ width: '100%', maxWidth: '300px', mb: 1 }}
        onClick={handleDownloadPdf}
      >
        Download PDF
      </Button>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<PictureAsPdfIcon />}
        sx={{ width: '100%', maxWidth: '300px', mb: 1 }}
        onClick={handleDownloadFavoritesPdf}
      >
        Download Bookmark PDF
      </Button>
      {(sortedDirectDownloads.length > 0 ||
        report.scrapedDownloadMaterials.length > 0) && (
        <>
          <Typography variant="h5" mt={4} mb={2}>
            Attachments
          </Typography>
          {sortedDirectDownloads.map((sdm, i) => (
            <Box key={`direct-${i}`} mb={1}>
              <a href={sdm.path || ''} target="_blank">
                {sdm.title || `Untitled #{i}`}
              </a>
            </Box>
          ))}
          {report.scrapedDownloadMaterials.map((sdm, i) => (
            <Box key={`json-${i}`} mb={1}>
              <a href={sdm.cleanedLink || ''} target="_blank">
                {sdm.linkText}
              </a>
            </Box>
          ))}
          <Button
            variant="outlined"
            color="primary"
            onClick={onClickOpenAll}
            sx={{ textAlign: 'center', mt: 2 }}
          >
            Open All
          </Button>
        </>
      )}
    </Paper>
  )
}

export default ReportOverviewActions
